/**
 * Fetch browser safe config from the server
 * @module services/config
 */
import request from 'services/request'
import { fromJS, List, Map } from 'immutable'
import { map as mapPromise } from 'bluebird'
import _get from 'lodash/get'
import { createAuthorization } from 'services/auth'
import strictUriEncode from '../../strict-uri-encode'

/**
 * Get browser safe config from the server
 */
export async function getNode ({ auth, server, nid }) {
  const res = await request
    .get(`${server}/node/${strictUriEncode(nid)}`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return fromJS(_get(res, 'body', {}))
}

export async function getNodeByQuery ({ server, query = {} }) {
  const { contentId, contentType } = query
  const res = await request
    .get(`${server}/node?contentId=${contentId}&contentType=${contentType}`)
    .set('accept', 'application/json')
  return fromJS(_get(res, 'body', {}))
}

/**
 * Get browser safe config from the server
 */
export async function getNodeList ({ auth, server, nids }) {
  const results = await mapPromise(nids.toSet().toList().toJS(), async (nid) => {
    try {
      return await getNode({ auth, server, nid })
    } catch (e) {
      return null
    }
  })
  return List(results).filter((v) => Map.isMap(v))
}
